if (!customElements.get('manual-download')) {
  class ManualDownload extends HTMLElement {
    category = 'all';
    searchValue = '';

    constructor() {
      super();
      this.elements = {
        categoryListWrapper: this.querySelector(".manual-download__category-list"),
        categoryList: this.querySelector(".manual-download__category-list ul"),
        categoryItems: this.querySelectorAll(".manual-download__category-list ul li"),
        manualList: this.querySelector(".manual-download__manual-list"),
        manualItems: this.querySelectorAll(".manual-download__manual-list ul li"),
        searchInput: this.querySelector(`input[type="search"]`),
      }
      for (const categoryItem of this.elements.categoryItems) {
        categoryItem.addEventListener('click', () => {
          this.elements.categoryList.querySelector('.active')?.classList.remove('active');
          categoryItem.classList.add('active');
          const category = categoryItem.getAttribute('data-category');
          this.category = category;
          this.filter();
          // Scroll into view
          if (categoryItem.offsetLeft < this.elements.categoryList.scrollLeft) {
            this.elements.categoryList.scrollTo({ left: categoryItem.offsetLeft, behavior: 'smooth' });
          }
          if ((categoryItem.offsetLeft + categoryItem.clientWidth) > (this.elements.categoryList.scrollLeft + window.innerWidth)) {
            this.elements.categoryList.scrollTo({ left: categoryItem.offsetLeft + categoryItem.clientWidth - window.innerWidth, behavior: 'smooth' });
          }
        });
      }
      this.elements.searchInput.addEventListener('input', () => {
        const value = this.elements.searchInput.value;
        this.searchValue = value;
        this.filter();
      });
    }

    filterSearch(manualTitle) {
      return this.searchValue != '' ? manualTitle.toLocaleLowerCase().includes(this.searchValue.toLocaleLowerCase()) : true;
    }

    filterCategory(manualCategory) {
      return this.category != 'all' ? (manualCategory != null && manualCategory == this.category) : true;
    }

    filter() {
      for (const manualItem of this.elements.manualItems) {
        const manualCategory = manualItem.getAttribute('data-category');
        const manualTitle = manualItem.querySelector('[data-title]').innerHTML;
        if (this.filterSearch(manualTitle) && this.filterCategory(manualCategory)) {
          manualItem.classList.add('active');
        } else if (manualItem.classList.contains('active')) {
          manualItem.classList.remove('active');
        }
      }
      if (!this.elements.manualList.querySelector('.active')) {
        this.elements.manualList.classList.add('empty');
      } else {
        this.elements.manualList.classList.remove('empty');
      }
    }

    connectedCallback() {
    }

  }
  customElements.define('manual-download', ManualDownload);
}